import { createFileRoute } from '@tanstack/react-router'
import DashboardPage from '@/pages/dashboard'
import { requireAuthenticated } from '@/shared/lib/route-guards'
import { GTM_PRODUCT_SCOPE } from '@/shared/lib/gtm-product-scope'
import { redirectToGtmEntry } from '@/shared/lib/gtm-route-guard'

export const Route = createFileRoute('/$lang/dashboard/')({
  beforeLoad: ({ context, params }) => {
    if (!GTM_PRODUCT_SCOPE.legacyWorkspaceUi) {
      redirectToGtmEntry(context, params)
    }
    requireAuthenticated(context, params)
  },
  component: DashboardPage,
  staticData: { layout: 'main' },
})
